export const ADDITIONAL_SIDEBAR_WIDTH = 360
export const MOBILE_FILTER_BUTTON_PADDING = 10